module.exports = __webpack_public_path__ + "img/public-schema-img-02.c466c6a9.png";